import { user } from '../../core/selectors.js';
import { go, render } from '../../core/shell.js';
import { S, UI, save } from '../../core/store.js';
import { toast } from '../../core/ui.js';
import { off, uid } from '../../core/util.js';
import { LEAD_POOL } from './view.js';

export const actions={
mtab(el){UI.mtab=el.dataset.t;render()},
mrange(el){UI.mr=Number(el.dataset.d);render()},
mconn(el){const id=el.dataset.id;S.mkt.conn[id]=S.mkt.conn[id]?0:1;save();render();toast(S.mkt.conn[id]?'Connected (demo)':'Disconnected')},
simlead(){
  const r=S.mkt.routing;const pool=LEAD_POOL[Math.floor(Math.random()*LEAD_POOL.length)];const owner=r.owners[r.next%r.owners.length];r.next++;
  const active=S.mkt.camps.filter(c=>c.status==='Active');const camp0=active[Math.floor(Math.random()*active.length)];
  const deal={id:uid(),name:pool[1]+' enquiry',client:pool[1],stage:'lead',amt:0,owner,close:off(30),src:'Meta lead form',campaign:camp0.name};
  S.deals.push(deal);S.stasks.push({id:uid(),title:'Call new lead, '+pool[0],who:owner,deal:deal.name,due:off(0),done:0});
  S.mkt.leads.unshift({id:uid(),name:pool[0],co:pool[1],camp:camp0.name,at:Date.now(),status:'In pipeline',owner,resp:'',dealId:deal.id});camp0.leads++;
  save();render();toast('New Meta lead is in the Sales Pipeline, and '+user(owner).name+' has a call task');
 },
leadgo(){UI.stab='pipeline';go('sales')}
};
